import React, { useState, useEffect } from "react";
import MainBodyModal from "./MainBodyModal";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableFooter,
  TablePagination,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Modal,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

import IconButton from "@mui/material/IconButton";

import {
  FirstPage,
  LastPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from "@mui/icons-material";

// Компонент для кастомной пагинации
const TablePaginationActions = (props) => {
  const { count, page, totalpage, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 1);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, totalpage);
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 1}
        aria-label="first page"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 1}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <Typography variant="body2" component="span">
        {page}
      </Typography>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= totalpage}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= totalpage}
        aria-label="last page"
      >
        <LastPage />
      </IconButton>
      <Typography variant="body2" component="span">
        Всего:{totalpage}
      </Typography>
    </Box>
  );
};

//Нижний блок с таблицей из 8 столбцов и 10 строк

const MainBody = ({
  responseFilmList,
  getDataFilmList,
}) => {
  const [page, setPage] = useState(1); // Текущая страница
  const [hoveredPoster, setHoveredPoster] = useState(null); // Для хранения постера
  const [hoverPosition, setHoverPosition] = useState({ top: 0, left: 0 }); // Позиция всплывающего постера

  const [openModal, setOpenModal] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState("");
  const [responseAPI, setResponseAPI] = useState();

  const handleMouseEnter = (event, element) => {
    const rect = event.target.getBoundingClientRect();
    setHoverPosition({
      top: rect.top + window.scrollY - 200,
      left: rect.left + window.scrollX - 400,
    }); // Позиция окна постера
    setHoveredPoster(element.poster); // Устанавливаем постер для отображения
  };

  const handleMouseLeave = () => {
    setHoveredPoster(null); // Скрываем постер при выходе курсора
  };

  // Обработчики для изменения страницы и количества строк на странице
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getDataFilmList(newPage);
  };

  const handleOpenModal = (format, element) => {
    setSelectedFormat(format);
    setResponseAPI(element);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedFormat();
  };
  // if (responseFilmList) {
  //   console.log(
  //     "responseFilmList year" + JSON.stringify(responseFilmList.data.data[0].year))
  // }

  return (
    <Box sx={{ flex: 1, padding: 1 }}>
      <Typography variant="h6" align="center" gutterBottom>
        Список фильмов
      </Typography>
      <TableContainer component={Paper} sx={{ maxHeight: "calc(100% - 40px)" }}>
        <Table sx={{ borderCollapse: "collapse" }}>
          <TableBody>
            {responseFilmList.data.data.map((element, index) => {

              const href = `/dev.api.mbase2.idc.md/api/movie/${element.id}`;

              https: return (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: !element.met_uid ? "#E0F7FA" : "inherit", // Голубой фон при отсутствии met_uid

                    height: "20px", // Установите желаемую высоту
                    "& td, & th": { padding: "8px" }, // Корректировка отступов для ячеек
                  }}
                >
                  <TableCell
                    sx={{
                      width: "30px",
                      border: "1px solid rgba(224, 224, 224, 1)", // Применяем границы
                    }}
                  >
                    {element.id}
                  </TableCell>
                  <TableCell
                    sx={{
                      width: "30px",
                      border: "1px solid rgba(224, 224, 224, 1)", // Применяем границы
                    }}
                  >
                    <a href={href} target="_blank" rel="noopener noreferrer">
                      {element.name}
                    </a>
                  </TableCell>
                  <TableCell
                    sx={{
                      width: "30px",
                      border: "1px solid rgba(224, 224, 224, 1)", // Применяем границы
                    }}
                  >
                    {element.year}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
          {/* Footer для отображения пагинации */}
          <TableFooter>
            <TableRow>
              <TableCell colSpan={5}>
                <TablePaginationActions
                  count={responseFilmList.data.pagination.total}
                  page={page}
                  onPageChange={handleChangePage}
                  totalpage={responseFilmList.data.pagination.totalPages}
                  rowsPerPage={responseFilmList.data.pagination.perPage}
                />
              </TableCell>
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      {responseAPI && (
        <MainBodyModal
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          responseAPI={responseAPI}
          selectedFormat={selectedFormat}
        />
      )}

      {/* Всплывающее окно с постером */}
      {hoveredPoster && (
        <Box
          sx={{
            position: "absolute",
            top: hoverPosition.top,
            left: hoverPosition.left,
            backgroundColor: "#fff",
            padding: 1,
            boxShadow: 3,
            zIndex: 1000,
          }}
        >
          <img
            src={hoveredPoster}
            alt="Постер фильма"
            width="280"
            height="420"
          />
        </Box>
      )}
    </Box>
  );
};

export default MainBody;
